import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUncheck8 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 82,
	height: 114,
	fill: "none",
	viewBox: "0 0 82 114",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		stroke: "#E0E0E0",
		strokeWidth: .75,
		d: "M79.272 1H2.728c-.476 0-.91.194-1.221.507C1.194 1.82 1 2.252 1 2.73v108.54c0 .477.194.91.507 1.223.312.313.743.507 1.221.507h76.544c.476 0 .91-.194 1.221-.507.314-.313.507-.746.507-1.223V2.73c0-.477-.194-.91-.507-1.223-.312-.313-.745-.507-1.221-.507z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#E0E0E0",
		stroke: "#E0E0E0",
		d: "M6.108 17.060h7.774v9.880h-7.774v-9.880zM17.075 17.060h7.772v.087h-7.772v-.087zM17.075 20.323h18.74v.088h-18.74v-.088zM47.780 17.060h7.774v9.880h-7.774v-9.880zM58.745 17.060h7.772v.087h-7.772v-.087zM58.745 20.323h18.74v.088h-18.74v-.088zM6.108 41.060h7.774v9.880h-7.774v-9.880zM17.075 41.060h7.772v.087h-7.772v-.087zM17.075 44.323h18.74v.088h-18.74v-.088zM47.780 41.060h7.774v9.880h-7.774v-9.880zM58.745 41.060h7.772v.087h-7.772v-.087zM58.745 44.323h18.74v.088h-18.74v-.088zM6.108 65.060h7.774v9.880h-7.774v-9.880zM17.075 65.060h7.772v.087h-7.772v-.087zM17.075 68.323h18.74v.088h-18.74v-.088zM47.780 65.060h7.774v9.880h-7.774v-9.880zM58.745 65.060h7.772v.087h-7.772v-.087zM58.745 68.323h18.74v.088h-18.74v-.088zM6.108 89.060h7.774v9.880h-7.774v-9.880zM17.075 89.060h7.772v.087h-7.772v-.087zM17.075 92.323h18.74v.088h-18.74v-.088zM47.780 89.060h7.774v9.880h-7.774v-9.880zM58.745 89.060h7.772v.087h-7.772v-.087zM58.745 92.323h18.74v.088h-18.74v-.088z"
	})]
});
export default SvgUncheck8;
